const extendedhours = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Extended Hours',
            },
            {
                "type": "tabs",
                "size": "8",
                "style": "",
                "class": "pr-4",
                "children": [
                    {
                        "title": "Extended Hours",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "onlineServicesTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "min-height: calc(100vh - 144px)",
                                    "class": "pl-3 pt-3",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Title',
                                            "placeholder": 'Enter Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr1": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "description": {
                                            "type": 'ckeditor',
                                            "label": 'Description',
                                            "placeholder": 'Enter Description',
                                            "required": true,
                                            "info": false,
                                            "character_count": 1000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr3": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },
                ]
            },

        ]
    }
]

export { extendedhours };